<template>
  <div class="conteudo">
    <b-container class="py-md-5">
      <b-row>
        <b-col class="col-12 col-lg-6 py-3 py-md-5">
          <h4 class="mb-0 text-white">Consignado</h4>
          <h3 class="mt-0 color-azul-1">PRIVADO FINLEV</h3>
          <h5 class="pt-2 fw-300">
            Crédito rápido e descomplicado, com desconto direto na folha de
            pagamento, exclusivo para profissionais da ASPEB com carteira
            assinada.
          </h5>
        </b-col>
        <b-col class="col-12 col-lg-6 py-3 py-md-5 text-right" align-self="end">
          <template>
            <b-breadcrumb class="justify-content-end">
              <b-breadcrumb-item href="http://www.finlev.com.br/"
                >Inicial</b-breadcrumb-item
              >
              <b-breadcrumb-item active>Simulação</b-breadcrumb-item>
            </b-breadcrumb>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 py-5">
          <div class="quadro-branco">
            <b-row>
              <b-col class="col-12 col-lg-6">
                <b-row>
                  <b-col class="col-12 col-lg-8 offset-lg-2">
                    <h4 class="text-center color-azul-1">
                      Quanto você precisa?
                    </h4>
                    <div class="container-input pt-4">
                      <b-form-input
                        placeholder="R$0,00"
                        class="custom-input"
                      ></b-form-input>
                    </div>
                    <div class="text-center">
                      <div class="py-4">
                        <b-dropdown
                          split
                          text="12 x"
                          class="m-2 custom-dropdown"
                        >
                          <b-dropdown-item href="#">12 x</b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <b-button size="lg" class="px-5 btn-verde-1"
                        >Simular empréstimo</b-button
                      >
                    </div>
                  </b-col>
                </b-row>
                <p class="pt-3 text-center">
                  Você está fazendo uma simulação de crédito sujeito a aprovação
                </p>
              </b-col>
              <b-col class="col-12 col-lg-6 align-self-center">
                <b-row>
                  <b-col class="col-12 col-lg-8 offset-lg-2">
                    <h4 class="text-center color-azul-2">Valor da parcela:</h4>
                    <div class="quadro-cinza text-center py-4 mt-4">
                      <h4 class="text-center color-azul-1">
                        R$122,48
                      </h4>
                      <p class="mb-0">
                        TAXA DE JUROS: 4,2% a.m.
                      </p>
                      <p class="mb-0">
                        CET TOTAL: 4,8% a.m.
                      </p>
                    </div>
                    <p class="mb-0 text-center mt-3">
                        <b-button size="lg" class="px-5 btn-verde-2"
                        >Contratar</b-button
                      >
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Simulacao",
};
</script>

<style>
.custom-input,
.custom-input::placeholder {
  text-align: center;
  color: #6bc49b;
  font-size: 28px;
  font-weight: 500;
  border-radius: 0px !important;
  border-left: none !important;
  border-top: none !important;
  border-right: none !important;
}
.custom-input {
  border-bottom: solid 2px grey !important;
}

.custom-dropdown .dropdown-menu {
  min-width: 1rem !important;
}

.custom-dropdown .btn-secondary {
  color: #6bc49b !important;
  font-size: 24px !important;
  font-weight: 500 !important;
  background-color: white !important;
  border: solid 1px #8f8e90 !important;
  border-radius: 15px !important;
  position: relative;
  z-index: 1;
}

.custom-dropdown .dropdown-toggle-split,
.custom-dropdown .dropdown-toggle-split:hover,
.custom-dropdown .dropdown-toggle-split:active,
.custom-dropdown .dropdown-toggle-split:focus {
  background-color: #6bc49b !important;
  color: white !important;
  padding-left: 35px;
  margin-left: -30px !important;
  z-index: 0;
  box-shadow: none !important;
}
</style>